import posthog from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_API_KEY as string | undefined;
const POSTHOG_HOST = (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ?? "https://app.posthog.com";

let posthogReady = false;

export function initPostHog(): void {
  if (!POSTHOG_KEY || POSTHOG_KEY === "your_posthog_api_key_here") {
    console.log("[posthog] VITE_POSTHOG_API_KEY not configured — skipping PostHog init.");
    return;
  }

  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    capture_pageview: true,
    autocapture: true,
    persistence: "localStorage",
    loaded(ph) {
      ph.capture("$pageview");
      posthogReady = true;
    },
  });
  posthogReady = true;
}

/**
 * Identify a user in PostHog after login so we can track
 * the Technician vs Buyer journey across the whole funnel.
 */
export function identifyUser(userId: string, properties: {
  email?: string;
  name?: string;
  role?: string;
  createdAt?: string;
}): void {
  if (!posthogReady) return;
  posthog.identify(userId, {
    email: properties.email,
    name: properties.name,
    role: properties.role,
    created_at: properties.createdAt,
  });
}

/** Reset PostHog identity on logout */
export function resetUser(): void {
  if (!posthogReady) return;
  posthog.reset();
}

/** Capture a custom event */
export function capture(event: string, properties?: Record<string, unknown>): void {
  if (!posthogReady) return;
  posthog.capture(event, properties);
}

/** Check a PostHog feature flag for A/B testing */
export function getFeatureFlag(flagKey: string): string | boolean | undefined {
  if (!posthogReady) return undefined;
  return posthog.getFeatureFlag(flagKey);
}

/** Check if a boolean feature flag is enabled */
export function isFeatureEnabled(flagKey: string): boolean {
  if (!posthogReady) return false;
  return posthog.isFeatureEnabled(flagKey) ?? false;
}

export default posthog;
